// CustomEvent.js
;(function() {
    "use strict"
    let _global;
    let timer;
    let prevDraggingEvent;
    const isTouchDevice = (() => {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function(query) {
            if(!window.matchMedia) {
                return false;
            }
            return window.matchMedia(query).matches;
        }
    
        if (('ontouchstart' in window || navigator.maxTouchPoints && navigator.maxTouchPoints !== 10) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }
    
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    })();
    const _eventCallback = function (option, behave, e) {
        const eventName = option.eventName;
        const callback = option.callback;
        if (behave && behave.indexOf('stop') > -1) e.stopPropagation();
        if (behave && behave.indexOf('prev') > -1) e.preventDefault();

        if (eventName === 'enter' && e.keyCode !== 13) return ;
        if (eventName === 'dragging') {
            callback(e, 'start');
            const $target = e.currentTarget;
            let $mask;
            // Create a mask layer to prevent click events during drag scrolling
            const createMaskLayer = function () {
                if ($mask) return ;
                $mask = document.createElement('div');
                $mask.style.position = 'absolute';
                $mask.style.top = '0';
                $mask.style.left = '0';
                $mask.style.width = '100%';
                $mask.style.height = '100%';
                $mask.style.background = 'rgba(0,0,0,0)';
                $mask.style.zIndex = '10000001';
                $target.appendChild($mask);
            }
            const removeMaskLayer = function () {
                if ($mask) {
                    $mask.parentNode.removeChild($mask);
                    $mask = undefined;
                }
            }
            const onMousemove = function (e) {
                // createMaskLayer();
                let event = e;
                if (e.touches && e.touches[0]) {
                    event = e.touches[0];
                }
                if (e.movementX === undefined) {
                    var clientX = event.clientX;
                    var clientY = event.clientY;
                    var movementX = 0;
                    var movementY = 0;
                    if (prevDraggingEvent) {
                        movementX = clientX - prevDraggingEvent.clientX;
                        movementY = clientY - prevDraggingEvent.clientY;
                    }
                    e.movementX = movementX;
                    e.movementY = movementY;
                    prevDraggingEvent = event;
                }
                if (Math.abs(e.movementX) > 1 || Math.abs(e.movementY) > 1) {
                    createMaskLayer();
                }
                callback && callback(e, 'dragging');
            }
            const onMouseup = function (ev) {
                ev.stopPropagation();
                ev.preventDefault();
                prevDraggingEvent = null;
                callback(ev, 'end');
                removeMaskLayer();
                document.body.removeEventListener('mousemove', onMousemove);
                document.body.removeEventListener('touchmove', onMousemove);
                window.removeEventListener('mouseup', onMouseup);
                window.removeEventListener('touchend', onMouseup);
            }
            document.body.addEventListener('mousemove', onMousemove);
            document.body.addEventListener('touchmove', onMousemove);
            window.addEventListener('mouseup', onMouseup);
            window.addEventListener('touchend', onMouseup);
            return ;
        }
        if (eventName === 'holddown') {
            const clearHolddownEvent = function () {
                if (timer === null) return ;
                clearInterval(timer);
                window.removeEventListener('mouseup', clearHolddownEvent);
                window.removeEventListener('touchend', clearHolddownEvent);
                timer = null;
            }
            timer = setInterval(callback, 30);
            window.addEventListener('mouseup', clearHolddownEvent);
            window.addEventListener('touchend', clearHolddownEvent);
            return ;
        }
        if (eventName === 'scrollEnd') {
            const $target = e.srcElement;
            const scrollLeft = $target.scrollLeft;
            const scrollTop = $target.scrollTop;
            const scrollWidth = $target.scrollWidth;
            const clientWidth = $target.clientWidth;
            const maxScrollWidth = scrollWidth - clientWidth;
            const scrollHeight = $target.scrollHeight;
            const clientHeight = $target.clientHeight;
            const maxScrollHeight = scrollHeight - clientHeight;
            const distance = 2;
            if (maxScrollWidth > 0 && (maxScrollWidth - scrollLeft) <= distance) {
                callback(e);
            }
            if (maxScrollHeight > 0 && (maxScrollHeight - scrollTop) <= distance) {
                callback(e);
            }
            return ;
        }
        callback && callback(e);
    };
    const _parseEventName = function (eventName) {
        switch (eventName) {
            case 'enter':
                return 'keyup';
            case 'dragging':
                return isTouchDevice ? 'touchstart' : 'mousedown';
            case 'holddown':
                return isTouchDevice ? 'touchstart' : 'mousedown';
            case 'scrollEnd':
                return 'scroll';
            default:
                return eventName;
        }
    }
    const AddEvent = function (dom, eventObject, behave) {
        if (!dom || !eventObject) return ;
        if (!behave) behave = '';
        for (let eventName in eventObject) {
            const eventCallback = eventObject[eventName];
            let _eventName = _parseEventName(eventName);
            dom.addEventListener(_eventName, _eventCallback.bind(this, {
                eventName: eventName,
                callback: eventCallback
            }, behave), false);
        }
    }
    const RemoveEvent = function (dom, eventName) {
        let _eventName = _parseEventName(eventName);
        dom.removeEventListener(_eventName, _eventCallback, false);
    }
    const plugin = {
        AddEvent: AddEvent,
        RemoveEvent: RemoveEvent
    };

    

    _global = (function(){ return this || (0, eval)('this'); }());
    if (typeof module !== "undefined" && module.exports) {
        module.exports = plugin;
    } else if (typeof define === "function" && define.amd) {
        define(function(){return plugin;});
    } else {
        !('plugin' in _global) && (_global.plugin = plugin);
    }
}());
